import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Button from '@material-ui/core/Button';
import { shadows } from '@material-ui/system';
import { Link as RouterLink } from 'react-router-dom'
import Link from '@material-ui/core/Link';
import Typography from "@material-ui/core/Typography";
//Farshid
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction, saveAComment, updateUserProfileAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
import Image from 'material-ui-image'
import * as MainConstants from "../../utils/MainConstants";
import ReactPlayer from 'react-player';

import CreditCardForm from "./CreditCardForm.js";

//import {updateUserProfileAction, saveAComment} from "../../redux/modules/login";
//import {bindActionCreators} from "redux";
//import {connect} from "react-redux";
//import {DEFAULT_VESPAAN_SERVER} from "../../utils/MainConstants";
//End Farshid



const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },

  multilineColor:{
    color:'black',
    backgroundColor:'#f5f7e8'
  }
});


class OrchidEducation extends Component {

  state = {
    age: '',
    name: 'hai',
    firstname: '',
    lastname:'',
    email:'',
    comment:'',
    userComment:{},
    selectedUser:{},
    showOrderForm:false
  };

  constructor(props) {
    super(props);

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleEmailChange= this.handleEmailChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.saveVisitorComment = this.saveVisitorComment.bind(this);

    this.handleAddress2Change = this.handleAddress2Change.bind(this);
    this.handleShowOrderFormChange = this.handleShowOrderFormChange.bind(this);



  }


  componentDidMount() {
    const { isAuthenticated ,updateUserProfileAction} = this.props;
    //isAuthenticated();
    //updateUserProfileAction(this.props.userProfile, this.props.loginData.accessToken);
    updateUserProfileAction(null, this.props.loginData.accessToken);
    //updateAuth();
    // console.log("Farshid the loginData " + this.props.loginData.accessToken)  ;

  }


  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleShowOrderFormChange = event => {
    this.setState({ showOrderForm:!this.state.showOrderForm });
  };

  handleFirstNameChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{firstname:event.target.value}));

    //this.setState({userComment , {{firstname:event.target.value }});
    // this.setState(Object.assign(this.state.firstname, event.target.value));
  }

  handleLastNameChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.lastname, event.target.value));
    this.setState(Object.assign(this.state.userComment,{lastname:event.target.value}));

  }

  handleEmailChange(event) {
    //event.preventDefault();
    //this.setState(Object.assign(this.state.email,event.target.value));
    this.setState(Object.assign(this.state.userComment,{email:event.target.value}));

  }
  handleCommentChange(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.userComment,{comment: event.target.value}));
  }


  saveVisitorComment(){
    const {saveAComment} = this.props;
    var  returnString="";
    var tempLastName =  this.state.userComment.lastname;
    var tempFirstName = this.state.userComment.firstname;
    var tempEmail = this.state.userComment.email;
    var tempComment = this.state.userComment.comment;


    if((tempFirstName == null) || (tempFirstName.length == 0)){
      alert("Please provide your first name!");
    }else {

      if ((tempLastName == null) || (tempLastName.length == 0)) {
        alert("Please provide your last name!");
      }else {

        if ((tempEmail == null) || (tempEmail.length == 0)) {
          alert("Please provide your Email!");
        } else {

          if ((tempEmail.indexOf("@") == -1)) {
            alert("Please provide proper Email address!");
          }else{
            if ((tempComment == null) || (tempComment.length == 0)) {
              alert("Please provide your comment!");
            }else{
              //Here send the data to the back end.
              saveAComment(DEFAULT_VESPAAN_SERVER.url, this.state.userComment);

            }
          }
        }
      }
    }

    return returnString;
  }

//Background color was backgroundColor:'#f4f3ed',

  handleAddress2Change(event) {
    //event.preventDefault();
    this.setState(Object.assign(this.state.selectedUser,{address2:event.target.value}));
  }



  render() {
    let shorOrderFormButtonText="";
    const { classes } = this.props;
    const MyLink = props => <RouterLink to="#top2" {...props} />
    if( !this.state.showOrderForm){
      shorOrderFormButtonText = "Show Order Form";
    }else{
      shorOrderFormButtonText = "Hide Order Form";
    }
    return (

      <div id="top1"  style={{  }}>
        <Grid container spacing={24}>

          <Grid   item xs={12} sm={12}  >

            <a href="/Home"   rel="noreferrer">
              <Typography component="h1" variant="h6" style = { { color:'blue', marginLeft:20}} >
                Back to Orchima Home
              </Typography>
            </a>
            <div    style = { {  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat'  }}>

              <h6 style = { {textAlign: 'center', alignSelf: 'center', color:'Red', fontSize:20}} ></h6>

              <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                      Orchid Educational information
                    </Typography>
                    {/*<Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      {MainConstants.APPLICATION_NAME}&trade; is thoughtfully designed specifically for orchids.
                      It allows you to soak the roots and bark by filling the side reservoir, and after 10 to 15 minutes,
                      you can easily drain the water using the built-in release valve at the base.

                      This eliminates the risk of damaging your orchid, as there’s no need to tilt the pot or remove an inner
                      liner to pour out excess water. The drainage process is clean, efficient, and minimizes splashing —
                      keeping both your plant and surrounding space protected.</Typography>*/}


                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                    By deepening our knowledge of orchids and their natural habitats, we gain the ability to safeguard them and
                    provide an environment where they can thrive beautifully for generations.
                    </Typography>
                    <br/>


                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h2" style = { { textAlign: 'left', alignSelf: 'left'  , color:'#BF360C', fontSize:30}}>
                      Light
                    </Typography>

                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      Orchids prefer bright, indirect sunlight. Too much direct sun can burn the leaves, while too
                      little light can prevent blooming. East-facing windows are ideal; south or west may need sheer curtains.
                    </Typography>
                    <br/>
                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h2" style = { { textAlign: 'left', alignSelf: 'left'  , color:'#BF360C', fontSize:30}}>
                      Watering
                    </Typography>

                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      Water once a week in most conditions, but let the medium dry slightly between waterings.
                      Use room-temperature water and avoid letting water sit in the crown (to prevent rot).
                      Always ensure good drainage—orchids hate “wet feet.”</Typography>
                    <br/>
                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h2" style = { { textAlign: 'left', alignSelf: 'left'  , color:'#BF360C', fontSize:30}}>
                      Airflow & Humidity
                    </Typography>

                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      Orchids thrive with 50–70% humidity.
                      Use a humidity tray or humidifier if your home is dry.
                      Good airflow helps prevent fungal and bacterial issues.</Typography>
                    <br/>
                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h2" style = { { textAlign: 'left', alignSelf: 'left'  , color:'#BF360C', fontSize:30}}>
                      Fertilizer
                    </Typography>

                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      “Weakly, weekly” is the rule: dilute orchid fertilizer to half or quarter strength and apply every week or two during the growing season.
                      In winter, fertilize less as growth slows.</Typography>
                    <br/>
                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h2" style = { { textAlign: 'left', alignSelf: 'left'  , color:'#BF360C', fontSize:30}}>
                      Potting Medium & Repotting
                    </Typography>

                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      Use specialized orchid bark never garden soil.
                      Repot every 1–2 years when the bark breaks down or roots crowd the pot.
                      Always repot after blooming, not during flowering. We recommend avoiding sphagnum moss, as it can be
                      difficult to maintain the right moisture balance. Moss tends to stay wet for too long, which prevents the orchid
                      roots from getting the air they need to breathe properly.</Typography>
                    <br/>
                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h2" style = { { textAlign: 'left', alignSelf: 'left'  , color:'#BF360C', fontSize:30}}>
                      Temperature
                    </Typography>

                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                      Most orchids enjoy 65–75°F (18–24°C) during the day and slightly cooler nights.
                      Avoid sudden drafts or extreme temperature changes.</Typography>
                    <br/>
                    <br/>
                  </Grid>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                </Grid>
              </div>



              <div style = { {textAlign: 'center', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>
                <Grid container spacing={24}>
                  <Grid   item xs={1} sm={1}  >
                  </Grid>
                  <Grid   item xs={10} sm={10}  >
                    <Typography variant="h6" component="h6" style = { {textAlign: 'left', alignSelf: 'center', paddingBottom:'200', marginBottom:'100', width:'300'}}>



                      <br/>




                      <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                        Replace the bark
                      </Typography>
                      Orchids thrive when their roots can breathe and excess moisture has a way out. A pot lacking drainage can trap water, inviting root disease and
                      decline. Repotting into a container with proper drainage—and repotting again every couple of years with fresh bark—gives your orchid a much better
                      chance to recover and flourish.
                      <br/>
                      For most orchids, you should replace the bark in the pot about **every 1–2 years**—sometimes sooner if:
                      <ol>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      The bark starts breaking down into smaller, spongy pieces
                        </li>

                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Water doesn’t drain as quickly as before
                      </li>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      You notice a sour or musty smell
                      </li>
                      <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      The orchid’s roots look crowded or unhealthy
                      </li>
                      </ol>
                      Bark gradually decomposes and compacts, which reduces airflow and can hold too much moisture—both bad for orchid roots. Spring, right after the plant finishes blooming, is often the easiest time to repot and refresh the bark.

                      <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                        How to  replace the bark
                      </Typography>
                      Step-by-Step: Replacing Orchid Bark
                      <ol>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                        Choose the right time-

                      Wait until the orchid has finished blooming.
                      Aim for spring or early summer, when the plant is actively growing.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                        Prepare your supplies-

                      Fresh orchid bark (medium-grade for most phalaenopsis)
                      Sterilized scissors or pruning shears
                      A clean pot (same size or just slightly bigger)
                      A shallow basin of lukewarm water
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Remove the orchid from the pot-

                      Gently squeeze the sides of the pot or tap it to loosen the bark.
                      Support the plant at the base and ease it out.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                     Clean the roots-

                      Shake off loose bark, then soak the roots in lukewarm water for a few minutes to soften remaining bits.
                      Trim away any mushy, brown, or dead roots—leave only firm, green, or silvery-white roots.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Prepare the new bark-

                      Soak the fresh bark in water for 30–60 minutes to remove dust and pre-moisten it.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                      Repot the orchid-

                      Place the orchid in the pot so that the base of the lowest leaves sits just above the rim.
                      Add bark gradually, tapping the pot to let it settle between roots without packing too tightly.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                     Water lightly and adjust care-

                      Give the plant a light watering to settle the bark.
                      Resume your normal watering schedule after about a week, letting the orchid adjust to its fresh medium.
                        </li>
                      </ol>
                      {/*}
                      <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                        Steps to Clean and Reassemble the FloraPot Valve
                      </Typography>
                      Sometimes small particles can become lodged in the valve, preventing it from closing tightly. This can cause the valve to leak and stop the bark from soaking properly.
                      To fix this issue, please follow the steps below:
                      <ol>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                          Place the pot in an area where it can be safely drained.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                          Remove the valve from the bottom of the FloraPot.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                          Disassemble the valve by twisting it until the cover comes off.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                          Inspect both pieces (as shown in the picture), wash them thoroughly, and ensure there is no debris inside the valve.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                          Reassemble the valve by screwing the cap back onto the main valve body.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                          Reattach the valve to the bottom of the pot.
                        </li>
                        <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'black', }}>
                          Your FloraPot is now ready for use again.
                        </li>
                      </ol>
                        */}
                      <br/>

                      {/*}
                      <Typography variant="h6" component="h2" style = { { textAlign: 'center', alignSelf: 'center'  , color:'#BF360C', fontSize:30}}>
                        Education information
                      </Typography>
                      <br/>


                      <br/>

                      1. Where Orchids Thrive in Elegance
                      Blurb:
                      Every detail of FloraPot™ is crafted for the world’s most exquisite blooms. From its seamless side-fill reservoir to its graceful drainage system, it delivers care with the sophistication your orchids deserve.
                      <br/>
                      2. The Art of Orchid Perfection
                      Blurb:
                      FloraPot™ transforms watering into a ritual of refinement. Gently soak, elegantly drain, and let your orchids bask in perfect balance — beauty made effortless.
                      <br/>
                      3. Grace in Every Drop
                      Blurb:
                      Designed for precision and poise, FloraPot™ nourishes orchids with a flawless flow. The built-in valve ensures clean, controlled drainage, protecting both your plant and its surroundings.
                      <br/>
                      4. Luxury Living for Your Finest Orchids
                      Blurb:
                      Orchids are nature’s jewels — and FloraPot™ is their perfect setting. Every feature blends function with luxury, ensuring healthy roots and radiant blooms.
                      <br/>
                      5. Elevating Orchid Care to an Art Form
                      Blurb:
                      FloraPot™ brings together exquisite design and botanical expertise. A pot that breathes, drains, and protects — for orchids that flourish in style.
                    <br/>*/}

                    </Typography>
                  </Grid>


                  <Grid item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
                  </Grid>

                </Grid>

              </div>
              <br/>
              <br/>
              <br/>
              <a href="/Home"   rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue', marginLeft:20}} >
                  Back to Orchima Home
                </Typography>
              </a>

              {/*<a href="/privacy"   rel="noreferrer" style={{paddingLeft:10, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                  Privacy Policy
                </Typography>
              </a>
              <a href="/Home"   rel="noreferrer" style={{paddingLeft:10, paddingBottom:20, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <Typography component="h2" variant="body1" style = { { color:'blue'}} >
                  FloraPot Home
                </Typography>
              </a>*/}
            </div>
          </Grid>
        </Grid>
      </div>



    );
  }
}

OrchidEducation.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    isAuthenticatedBool: state.login.isAuthenticatedBool,
    userProfile: state.login.userProfile,
    loginData:state.login.loginData,

    //auth:state.login.loginData,
    //CompanyDeleteResponse:state.account.deleteCompanyResp,
    //CompanySaveResponse:state.account.saveCompanyResp,
    //locationsArray:state.location.locationsArray,
    //vcArray:state.videocontroller.vcArray,
    //camerasArray:state.camera.camerasArray,
    //errorCMsg:state.account.errorCMsg,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    //login:login,
    //handleAuthentication:handleAuthentication,
    //isAuthenticated:isAuthenticated,
    updateUserProfileAction:updateUserProfileAction,
    saveAComment:saveAComment,
    //updateAuth:updateAuth,

  }, dispatch);
};

//export default BiomassView;
//export default withStyles(styles)(AboutPlateWiz);




//export default withStyles(styles)(AppView);
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OrchidEducation));
